import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PlanDTO } from "src/app/data/schema/Billing/Plans/PlanDTO";
import { GetDataDTO } from "src/app/data/schema/Common/GetDataDTO";
import { ObjectUtils } from "src/app/utils/ObjectUtils";
import { environment } from "src/environments/environment";
import { PlanCreateDTO } from "../../schema/Billing/Plans/PlanCreateDTO";
import { GetQueryParametersDTO } from "../../schema/Common/GetQueryParametersDTO";

@Injectable({
    providedIn: "root"
})
export class ApiBillingPlanService {
    private relativePath: string;

    constructor(private http: HttpClient) {
        this.relativePath = `${environment.billing.url}/api/v1/Plans`;
    }

    public list(queryParameters: GetQueryParametersDTO): Observable<GetDataDTO<PlanDTO>> {
        const httpParams = new HttpParams({
            fromObject: ObjectUtils.removeNullUndefinedFields(queryParameters) as any
        });

        return this.http.get<GetDataDTO<PlanDTO>>(`${this.relativePath}`, {
            params: httpParams
        });
    }

    public get(id: string, subscriptionId: string): Observable<PlanDTO> {
        const params = new HttpParams().set("subscriptionId", subscriptionId);

        return this.http.get<PlanDTO>(`${this.relativePath}/${id}`, {
            params: params
        });
    }

    public create(planTo: PlanCreateDTO): Observable<PlanDTO> {
        return this.http.post<PlanDTO>(`${this.relativePath}`, planTo);
    }

    public update(id: string, dto: PlanDTO): Observable<PlanDTO> {
        return this.http.put<PlanDTO>(`${this.relativePath}/${id}`, dto);
    }
}
